<template>
    <router-view></router-view>
</template>
<script setup>
import { RouterView } from 'vue-router';

</script>
<style lang='scss' scoped>
</style>